import { useState } from 'react'
import styled from 'styled-components'

import { normalizeKeys } from '../../../components/utils/propsUtils'
import TrackVisibility from '../../../components/utils/TrackVisibility'
import { isExperience } from '../../../components/utils/listingUtils'

import AdventureCardList from '../Adventures/AdventureCardList'
import MapWithListing from '../../../components/maps/ListingMap'
import { Marker } from '../../../components/maps/ListingMap/markers'

import { Legend, LegendItem } from './ListingLegend'
import { Section, SubSection, SectionTitle } from './shared'

const MapWrapper = styled.div`
  width: 100%;
  height: 576px;
`

export default ({ listing }) => {
  const [showMap, setShowMap] = useState(false)
  const adventures = listing.adventures.off_property

  const mapAdventures =
    adventures?.map((adventure) => ({
      id: adventure.id,
      slug: adventure.adventure_type.slug,
      type: 'Adventure',
      location: [adventure.location.lat, adventure.location.lng],
      notBucketListable: adventure.location_type === 'on_property',
      adventure: {
        ...normalizeKeys(adventure),
        storyteller: adventure?.storyteller && {
          ...normalizeKeys(adventure.storyteller),
          avatar: {
            thumbLg: adventure.storyteller.avatar_url,
          },
        },
      },
    })) || []

  const mapListing = {
    id: listing.id,
    slug: listing?.listing_subcategory?.slug || listing?.listing_type?.slug,
    type: 'Listing',
    location: [listing.location.lat, listing.location.lng],
    disablePopup: true,
    listing,
  }

  return (
    <Section borderTop>
      <SectionTitle>Location</SectionTitle>

      {!isExperience(listing) && adventures.length > 0 && (
        <div>
          <SubSection intro>
            <p>
              The map shows the listing location and awesome adventures nearby.
            </p>
          </SubSection>

          <Legend>
            <LegendItem>
              <Marker jungle standalone>
                <i
                  className={`icon icon-${
                    listing.listing_subcategory
                      ? listing.listing_subcategory.slug
                      : listing.listing_type.slug
                  }`}
                />
              </Marker>
              <span>Listing location</span>
            </LegendItem>
            <LegendItem>
              <Marker standalone>
                <i className="icon icon-experiences" />
              </Marker>
              <span>Adventures nearby</span>
            </LegendItem>
          </Legend>
        </div>
      )}

      <SubSection moreMargin>
        <TrackVisibility
          onChange={(isVisible) => {
            if (isVisible) setShowMap(true)
          }}
        >
          <MapWrapper>
            <MapWithListing
              listing={mapListing}
              adventures={mapAdventures}
              analyticsSource="listing_page"
              hide={!showMap}
            />
          </MapWrapper>
        </TrackVisibility>
      </SubSection>

      {adventures.length > 0 && (
        <div>
          <SectionTitle id="adventures">Adventures Nearby</SectionTitle>
          <SubSection intro>
            <p>
              Here are some details about the adventures nearby. Refer to the
              map for their location.
            </p>
          </SubSection>

          <AdventureCardList
            adventures={adventures}
            listingId={listing?.id?.toString()}
          />
        </div>
      )}
    </Section>
  )
}
